export default __webpack_public_path__ + "static/media/incomplete_agent_example.8af8649d.png";